import script from "./DisplayOrderSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayOrderSelector.vue?vue&type=script&setup=true&lang=js"

import "./DisplayOrderSelector.vue?vue&type=style&index=0&id=b3cadaf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3cadaf0"]])

export default __exports__